export const TEMPLATE_COM_SALA = 'Paciente {paciente}, favor dirigir-se ao {sala}.';
export const TEMPLATE_SEM_SALA = 'Paciente {paciente}, favor comparecer.';
export const STORAGE_KEY = 'painel-chamadas-v1';
export const MAX_ANUNCIOS = 2;
export const INTERVALO_REPETICAO_MS = 8000;

export function normalizeCnes(valor) {
  const digitos = String(valor || '').replace(/\D/g, '');
  if (digitos.length < 6 || digitos.length > 7) return null;
  return digitos.padStart(7, '0');
}

function preencher(template, valores) {
  return Object.entries(valores).reduce(
    (texto, [chave, valor]) => texto.split(`{${chave}}`).join(valor),
    template
  );
}

export function buildAnnouncement({ paciente, sala, tipo, templateComSala, templateSemSala }) {
  const nome = String(paciente || '').trim();
  if (!nome) return null;
  const salaLimpa = String(sala || '').trim();
  const tipoLimpo = String(tipo || '').trim();
  const template = salaLimpa ? templateComSala : templateSemSala;
  if (!template || !String(template).trim()) return null;
  return preencher(template, {
    paciente: nome,
    sala: salaLimpa,
    tipo: tipoLimpo,
  }).replace(/\s{2,}/g, ' ').replace(/\s+([,.])/g, '$1').trim();
}

export function aceitavel(call, config) {
  if (!call?.dedupKey || !String(call.paciente || '').trim()) return false;
  if (normalizeCnes(call.cnes) !== normalizeCnes(config.cnes)) return false;
  const filtro = String(config.sala || '').trim().toLocaleLowerCase('pt-BR');
  const sala = String(call.sala || '').trim().toLocaleLowerCase('pt-BR');
  if (filtro && sala !== filtro) return false;
  return true;
}

export function vezesAnunciadas(anuncios, id) {
  return Number(anuncios?.[id]?.vezes || 0);
}

export function deveFalar(anuncios, id, maximo = MAX_ANUNCIOS) {
  return Boolean(id) && vezesAnunciadas(anuncios, id) < maximo;
}

export function registrarAnuncio(anuncios, id, now, retentionMs = 24 * 60 * 60 * 1000) {
  const proximo = {};
  Object.entries(anuncios || {}).forEach(([item, valor]) => {
    if (now - Number(valor?.em || 0) < retentionMs) proximo[item] = valor;
  });
  proximo[id] = { vezes: vezesAnunciadas(proximo, id) + 1, em: now };
  return proximo;
}

export function montarHistorico(anteriores, recebidas, limite = 3) {
  const vistos = new Set();
  const saida = [];
  [...(recebidas || [])].reverse().concat(anteriores || []).forEach((item) => {
    if (!item?.dedupKey || vistos.has(item.dedupKey) || saida.length >= limite) return;
    vistos.add(item.dedupKey);
    saida.push(item);
  });
  return saida;
}

export function rememberSpoken(spoken, key, now, retentionMs = 24 * 60 * 60 * 1000) {
  const proximo = {};
  Object.entries(spoken || {}).forEach(([item, instante]) => {
    if (now - Number(instante) < retentionMs) proximo[item] = instante;
  });
  proximo[key] = now;
  return proximo;
}

export function defaultConfig() {
  return {
    token: '',
    cnes: '',
    sala: '',
    intervaloMs: 2000,
    audio: true,
    templateComSala: TEMPLATE_COM_SALA,
    templateSemSala: TEMPLATE_SEM_SALA,
    voiceURI: '',
    deviceId: '',
    spoken: {},
    anuncios: {},
    pendingAcks: [],
  };
}

export function loadConfig(storage) {
  try {
    const bruto = storage.getItem(STORAGE_KEY);
    if (!bruto) return null;
    const json = JSON.parse(bruto);
    return {
      ...defaultConfig(),
      ...json,
      spoken: json.spoken || {},
      anuncios: json.anuncios || {},
      pendingAcks: json.pendingAcks || [],
    };
  } catch {
    return null;
  }
}

export function saveConfig(storage, config) {
  storage.setItem(STORAGE_KEY, JSON.stringify(config));
}
